import axiosApi from "./api";
import { getAction } from "./manage";

const url = {
  ksList: "sys/category/loadTreeRoot",
};

export function getKsList(params) {
  return getAction(url.ksList, params);
}

/**
 * 获取案例列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNo - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {string} params.status - 是否获奖
 * @param {string} params.phone - 评委手机号
 * @returns {Promise} - 返回评委列表
 */
export function getCaseList(params) {
  return axiosApi({
    url: "/tc/hosp/activityParticipateInfo/list",
    method: "get",
    params,
  });
}

/**
 * 获取案例详情
 * @param {Object} params - 查询参数
 * @param {number} params.id - 案例ID
 * @returns {Promise} - 返回案例详情
 */
export function getHistoryDetail(id) {
  return axiosApi({
    url: `/tc/hosp/activityParticipateInfo/queryById`,
    method: "get",
    params: { id },
  });
}

/**
 * 获取是否为获奖作品字典表
 * @returns {Promise} - 返回字典表数据
 */
export function getIsAwardedDict() {
  return axiosApi({
    url: "/tc/common/dict/is_award/list",
    method: "get",
  });
}

/**
 * 获取所属年份字典表
 * @returns {Promise} - 返回字典表数据
 */
export function getYearDict() {
  return axiosApi({
    url: "/tc/common/dict/belong_year/list",
    method: "get",
  });
}

/**
 * 根据编码获取对应字典的id
 * @param {Object} params - 查询参数
 * @param {string} params.code - 案例编码
 * @returns {Promise} - 返回字典id
 */
export function getDictIdByCode(params) {
  return axiosApi({
    url: "/sys/category/rootList",
    method: "get",
    params,
  });
}

/**
 * 根据字典id获取字典列表
 * @param {Object} params - 查询参数
 * @param {string} params.id - 字典id
 * @returns {Promise} - 返回字典列表
 */
export function getDictListById(params) {
  return axiosApi({
    url: "/sys/dictItem/list",
    method: "get",
    params,
  });
}

/**
 * 获取所有字典列表
 * @returns {Promise} - 返回字典表数据
 */
export function getAllDict(params) {
  return axiosApi({
    url: `/tc/common/dict/${params}/list`,
    method: "get",
  });
}

/* 获取所属科室列表
 * @returns {Promise} - 返回字典表数据
 */
export function getKsDict() {
  return axiosApi({
    url: "/sys/category/loadTreeRoot",
    method: "get",
    params: {
      async: false,
      pcode: "ks",
    },
  });
}

// 字典重复校验接口
export function checkDict(params) {
  return axiosApi({
    url: "/tc/common/dictItemCheck",
    method: "get",
    params,
  });
}

// 字典项新增验接口
export function addDictItem(data) {
  return axiosApi({
    url: "/tc/common/add",
    method: "post",
    data,
  });
}
